const disabledTags = [
  "mj-accordion",
  "mj-heor",
  "mj-navbar",
  "mj-table",
  "mj-wrapper",
];

export default (mjml: string) => {
  if (!mjml.includes("<mj-section")) {
    if (!mjml.includes("<mj-column")) {
      mjml = `<mj-column>${mjml}</mj-column>`;
    }
    mjml = `<mj-section>${mjml}</mj-section>`;
  }

  mjml = mjml.replaceAll("<br>", "<br/>");
  mjml = expandSelfClosingMjTags(mjml);
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(mjml, "text/html");
  const body = xmlDoc.querySelector("mj-body") || xmlDoc.querySelector("body");
  if (!body) {
    return null;
  }
  const mjmlJson = Array.from(body.children)
    .map((child) => {
      if (
        child.nodeType === Node.ELEMENT_NODE &&
        child.tagName.toLowerCase().startsWith("mj-")
      ) {
        return parseElement(child as Element, Array.from(body.children).length);
      }
      return null;
    })
    .filter((child) => child !== null);
  return mjmlJson;
};

function expandSelfClosingMjTags(mjml: string): string {
  return mjml.replace(
    /<(?<tag>mj-[a-zA-Z0-9_-]+)(?<attrs>[^<>]*?)\s*\/>/g,
    (_match, tag, attrs) => {
      return `<${tag}${attrs}></${tag}>`;
    }
  );
}

function parseElement(element: Element, numOfSiblings: number = 0) {
  const tagName = element.tagName.toLowerCase();

  if (disabledTags.includes(tagName)) {
    return null;
  }
  const attributes: Record<string, string | boolean> = {};
  const children: any[] = [];

  if (tagName === "mj-group") {
    for (const child of element.children) {
      if (child.tagName.toLowerCase().startsWith("mj-")) {
        children.push(parseElement(child, element.children.length));
      }
    }
    return children;
  }

  for (const attr of element.attributes) {
    attributes[attr.name] = attr.value;
  }

  if (
    tagName === "mj-text" ||
    tagName === "mj-button" ||
    tagName === "mj-raw"
  ) {
    let content = element.innerHTML;

    if (tagName === "mj-text") {
      if (element.getAttribute("font-weight") === "bold") {
        content = `<strong>${content}</strong>`;
      }

      content = `<div>${content}</div>`;
    }

    return {
      tagName: tagName,
      attributes: attributes,
      content: content,
    };
  }

  if (tagName === "mj-column" && !element.hasAttribute("width")) {
    attributes.width = `${Math.round(100 / numOfSiblings)}%`;
  }

  for (const child of element.children) {
    if (child.tagName.toLowerCase().startsWith("mj-")) {
      const childElement = parseElement(child, element.children.length);
      if (Array.isArray(childElement)) {
        for (const item of childElement.filter((item) => item !== null)) {
          children.push(item);
        }
        attributes["in-group"] = true;
      } else if (childElement) {
        children.push(childElement);
      }
    }
  }

  if (children.length === 0) {
    return {
      tagName: tagName,
      attributes: attributes,
    };
  }
  return {
    tagName: tagName,
    attributes: attributes,
    children: children,
  };
}
